$(document).ready(function () {
  function openSearchDrawer () {
    $('.search-drawer').addClass('show')
    $('body').addClass('hidden-overflow')
    $('.search-drawer__icon-close').on('click', searchDrawerClose)
    $('.search-drawer__backdrop').on('click', searchDrawerClose)
    $('.search-drawer__input').on('keyup change',searchProcess)
  }
  function searchDrawerClose () {
    $('.search-drawer').removeClass('show')
    $('body').removeClass('hidden-overflow')
    $('.search-drawer__icon-close').off('click')
    $('.search-drawer__backdrop').off('click')
    $('.search-drawer__input').off('keyup change')
  }
  function setNewMarkup (markup, resultsLength ) {
    const shopURL = $('body').data('shop-url');
    const inputValue = $('.search-drawer__input').val()
    if ( resultsLength > 0) {
      $('.search-drawer__results').html(markup)
      if ( resultsLength === 10 ) $('.search-drawer__search-link').html('<a class="search-drawer__link custom-first-link flex" href="' + shopURL + '/search?type=product&q=' + inputValue +'"><span> Show more products </span></a>')
    } else {
      $('.search-drawer__results').html('<li class="search-drawer__result-no-results custom-first-link">SORRY, NO RESULTS!</li>')
    }
  }
  function createNewMarkup (data) {
    const resultsMarkup = new DOMParser().parseFromString(data, 'text/html')
    const newMarkup = resultsMarkup.querySelector('.search-drawer__results').innerHTML;
    const resultsLength = $(resultsMarkup).find('.search-drawer__result').length
    setNewMarkup(newMarkup, resultsLength)
  }
  async function getSearchResults (inputValue) {
    const shopURL = $('body').data('shop-url');
    const searchPath = shopURL + '/search/suggest?q=';
    const searchURL =  searchPath + inputValue + '&resources[type]=product&section_id=search-drawer';
    try {
      const response = await fetch(searchURL)
      const data = await response.text()
      if (!response.ok) {
        throw new Error(`${response.status}: ${data}`);
      }
      createNewMarkup(data)
    } catch (error) {
      console.log('error', error)
    }
  }
 async function searchProcess () {
    const searchValue = $(this).val()
    if( searchValue.length < 3 ) {
      $('.search-drawer__results').html('')
      $('.search-drawer__search-link').html('')
      return
    }
  await getSearchResults (encodeURI(searchValue))
  }
  $('.search-open').on('click', openSearchDrawer)
})